import React from "react";
import LandingPage from "../../Components/services/retouching/LandingPage";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import RetouchingFaqs from "../../Components/services/retouching/RetouchingFaqs";

const Retouching = () => {
  return (
    <div>
      <Navbar />
      <LandingPage />
      <RetouchingFaqs />
      <Footer />
    </div>
  );
};

export default Retouching;
